document.addEventListener("DOMContentLoaded", function () {
  const countries = [
    { code: "AD", name: "Andorra", dialCode: "+376", flag: "ad.svg" },
    { code: "AE", name: "United Arab Emirates", dialCode: "+971", flag: "ae.svg" },
    { code: "AF", name: "Afghanistan", dialCode: "+93", flag: "af.svg" },
    { code: "AG", name: "Antigua and Barbuda", dialCode: "+1", flag: "ag.svg" },
    { code: "AI", name: "Anguilla", dialCode: "+1", flag: "ai.svg" },
    { code: "AL", name: "Albania", dialCode: "+355", flag: "al.svg" },
    { code: "AM", name: "Armenia", dialCode: "+374", flag: "am.svg" },
    { code: "AO", name: "Angola", dialCode: "+244", flag: "ao.svg" },
    { code: "AQ", name: "Antarctica", dialCode: "+672", flag: "aq.svg" },
    { code: "AR", name: "Argentina", dialCode: "+54", flag: "ar.svg" },
    { code: "AS", name: "American Samoa", dialCode: "+1", flag: "as.svg" },
    { code: "AT", name: "Austria", dialCode: "+43", flag: "at.svg" },
    { code: "AU", name: "Australia", dialCode: "+61", flag: "au.svg" },
    { code: "AW", name: "Aruba", dialCode: "+297", flag: "aw.svg" },
    { code: "AX", name: "Åland Islands", dialCode: "+358", flag: "ax.svg" },
    { code: "AZ", name: "Azerbaijan", dialCode: "+994", flag: "az.svg" },
    { code: "BA", name: "Bosnia and Herzegovina", dialCode: "+387", flag: "ba.svg" },
    { code: "BB", name: "Barbados", dialCode: "+1", flag: "bb.svg" },
    { code: "BD", name: "Bangladesh", dialCode: "+880", flag: "bd.svg" },
    { code: "BE", name: "Belgium", dialCode: "+32", flag: "be.svg" },
    { code: "BF", name: "Burkina Faso", dialCode: "+226", flag: "bf.svg" },
    { code: "BG", name: "Bulgaria", dialCode: "+359", flag: "bg.svg" },
    { code: "BH", name: "Bahrain", dialCode: "+973", flag: "bh.svg" },
    { code: "BI", name: "Burundi", dialCode: "+257", flag: "bi.svg" },
    { code: "BJ", name: "Benin", dialCode: "+229", flag: "bj.svg" },
    { code: "BL", name: "Saint Barthélemy", dialCode: "+590", flag: "bl.svg" },
    { code: "BM", name: "Bermuda", dialCode: "+1", flag: "bm.svg" },
    { code: "BN", name: "Brunei", dialCode: "+673", flag: "bn.svg" },
    { code: "BO", name: "Bolivia", dialCode: "+591", flag: "bo.svg" },
    { code: "BQ", name: "Caribbean Netherlands", dialCode: "+599", flag: "bq.svg" },
    { code: "BR", name: "Brazil", dialCode: "+55", flag: "br.svg" },
    { code: "BS", name: "Bahamas", dialCode: "+1", flag: "bs.svg" },
    { code: "BT", name: "Bhutan", dialCode: "+975", flag: "bt.svg" },
    { code: "BV", name: "Bouvet Island", dialCode: "+47", flag: "bv.svg" },
    { code: "BW", name: "Botswana", dialCode: "+267", flag: "bw.svg" },
    { code: "BY", name: "Belarus", dialCode: "+375", flag: "by.svg" },
    { code: "BZ", name: "Belize", dialCode: "+501", flag: "bz.svg" },
    { code: "CA", name: "Canada", dialCode: "+1", flag: "ca.svg" },
    { code: "CC", name: "Cocos (Keeling) Islands", dialCode: "+61", flag: "cc.svg" },
    { code: "CD", name: "DR Congo", dialCode: "+243", flag: "cd.svg" },
    { code: "CF", name: "Central African Republic", dialCode: "+236", flag: "cf.svg" },
    { code: "CG", name: "Congo", dialCode: "+242", flag: "cg.svg" },
    { code: "CH", name: "Switzerland", dialCode: "+41", flag: "ch.svg" },
    { code: "CI", name: "Ivory Coast", dialCode: "+225", flag: "ci.svg" },
    { code: "CK", name: "Cook Islands", dialCode: "+682", flag: "ck.svg" },
    { code: "CL", name: "Chile", dialCode: "+56", flag: "cl.svg" },
    { code: "CM", name: "Cameroon", dialCode: "+237", flag: "cm.svg" },
    { code: "CN", name: "China", dialCode: "+86", flag: "cn.svg" },
    { code: "CO", name: "Colombia", dialCode: "+57", flag: "co.svg" },
    { code: "CR", name: "Costa Rica", dialCode: "+506", flag: "cr.svg" },
    { code: "CU", name: "Cuba", dialCode: "+53", flag: "cu.svg" },
    { code: "CV", name: "Cape Verde", dialCode: "+238", flag: "cv.svg" },
    { code: "CW", name: "Curaçao", dialCode: "+599", flag: "cw.svg" },
    { code: "CX", name: "Christmas Island", dialCode: "+61", flag: "cx.svg" },
    { code: "CY", name: "Cyprus", dialCode: "+357", flag: "cy.svg" },
    { code: "CZ", name: "Czech Republic", dialCode: "+420", flag: "cz.svg" },
    { code: "DE", name: "Germany", dialCode: "+49", flag: "de.svg" },
    { code: "DJ", name: "Djibouti", dialCode: "+253", flag: "dj.svg" },
    { code: "DK", name: "Denmark", dialCode: "+45", flag: "dk.svg" },
    { code: "DM", name: "Dominica", dialCode: "+1", flag: "dm.svg" },
    { code: "DO", name: "Dominican Republic", dialCode: "+1", flag: "do.svg" },
    { code: "DZ", name: "Algeria", dialCode: "+213", flag: "dz.svg" },
    { code: "EC", name: "Ecuador", dialCode: "+593", flag: "ec.svg" },
    { code: "EE", name: "Estonia", dialCode: "+372", flag: "ee.svg" },
    { code: "EG", name: "Egypt", dialCode: "+20", flag: "eg.svg" },
    { code: "EH", name: "Western Sahara", dialCode: "+212", flag: "eh.svg" },
    { code: "ER", name: "Eritrea", dialCode: "+291", flag: "er.svg" },
    { code: "ES", name: "Spain", dialCode: "+34", flag: "es.svg" },
    { code: "ET", name: "Ethiopia", dialCode: "+251", flag: "et.svg" },
    { code: "FI", name: "Finland", dialCode: "+358", flag: "fi.svg" },
    { code: "FJ", name: "Fiji", dialCode: "+679", flag: "fj.svg" },
    { code: "FK", name: "Falkland Islands", dialCode: "+500", flag: "fk.svg" },
    { code: "FM", name: "Micronesia", dialCode: "+691", flag: "fm.svg" },
    { code: "FO", name: "Faroe Islands", dialCode: "+298", flag: "fo.svg" },
    { code: "FR", name: "France", dialCode: "+33", flag: "fr.svg" },
    { code: "GA", name: "Gabon", dialCode: "+241", flag: "ga.svg" },
    { code: "GB", name: "United Kingdom", dialCode: "+44", flag: "gb.svg" },
    { code: "GD", name: "Grenada", dialCode: "+1", flag: "gd.svg" },
    { code: "GE", name: "Georgia", dialCode: "+995", flag: "ge.svg" },
    { code: "GF", name: "French Guiana", dialCode: "+594", flag: "gf.svg" },
    { code: "GG", name: "Guernsey", dialCode: "+44", flag: "gg.svg" },
    { code: "GH", name: "Ghana", dialCode: "+233", flag: "gh.svg" },
    { code: "GI", name: "Gibraltar", dialCode: "+350", flag: "gi.svg" },
    { code: "GL", name: "Greenland", dialCode: "+299", flag: "gl.svg" },
    { code: "GM", name: "Gambia", dialCode: "+220", flag: "gm.svg" },
    { code: "GN", name: "Guinea", dialCode: "+224", flag: "gn.svg" },
    { code: "GP", name: "Guadeloupe", dialCode: "+590", flag: "gp.svg" },
    { code: "GQ", name: "Equatorial Guinea", dialCode: "+240", flag: "gq.svg" },
    { code: "GR", name: "Greece", dialCode: "+30", flag: "gr.svg" },
    { code: "GS", name: "South Georgia", dialCode: "+500", flag: "gs.svg" },
    { code: "GT", name: "Guatemala", dialCode: "+502", flag: "gt.svg" },
    { code: "GU", name: "Guam", dialCode: "+1", flag: "gu.svg" },
    { code: "GW", name: "Guinea-Bissau", dialCode: "+245", flag: "gw.svg" },
    { code: "GY", name: "Guyana", dialCode: "+592", flag: "gy.svg" },
    { code: "HK", name: "Hong Kong", dialCode: "+852", flag: "hk.svg" },
    { code: "HM", name: "Heard & McDonald Islands", dialCode: "+672", flag: "hm.svg" },
    { code: "HN", name: "Honduras", dialCode: "+504", flag: "hn.svg" },
    { code: "HR", name: "Croatia", dialCode: "+385", flag: "hr.svg" },
    { code: "HT", name: "Haiti", dialCode: "+509", flag: "ht.svg" },
    { code: "HU", name: "Hungary", dialCode: "+36", flag: "hu.svg" },
    { code: "ID", name: "Indonesia", dialCode: "+62", flag: "id.svg" },
    { code: "IE", name: "Ireland", dialCode: "+353", flag: "ie.svg" },
    { code: "IL", name: "Israel", dialCode: "+972", flag: "il.svg" },
    { code: "IM", name: "Isle of Man", dialCode: "+44", flag: "im.svg" },
    { code: "IN", name: "India", dialCode: "+91", flag: "in.svg" },
    { code: "IO", name: "British Indian Ocean Territory", dialCode: "+246", flag: "io.svg" },
    { code: "IQ", name: "Iraq", dialCode: "+964", flag: "iq.svg" },
    { code: "IR", name: "Iran", dialCode: "+98", flag: "ir.svg" },
    { code: "IS", name: "Iceland", dialCode: "+354", flag: "is.svg" },
    { code: "IT", name: "Italy", dialCode: "+39", flag: "it.svg" },
    { code: "JE", name: "Jersey", dialCode: "+44", flag: "je.svg" },
    { code: "JM", name: "Jamaica", dialCode: "+1", flag: "jm.svg" },
    { code: "JO", name: "Jordan", dialCode: "+962", flag: "jo.svg" },
    { code: "JP", name: "Japan", dialCode: "+81", flag: "jp.svg" },
    { code: "KE", name: "Kenya", dialCode: "+254", flag: "ke.svg" },
    { code: "KG", name: "Kyrgyzstan", dialCode: "+996", flag: "kg.svg" },
    { code: "KH", name: "Cambodia", dialCode: "+855", flag: "kh.svg" },
    { code: "KI", name: "Kiribati", dialCode: "+686", flag: "ki.svg" },
    { code: "KM", name: "Comoros", dialCode: "+269", flag: "km.svg" },
    { code: "KN", name: "Saint Kitts and Nevis", dialCode: "+1", flag: "kn.svg" },
    { code: "KP", name: "North Korea", dialCode: "+850", flag: "kp.svg" },
    { code: "KR", name: "South Korea", dialCode: "+82", flag: "kr.svg" },
    { code: "KW", name: "Kuwait", dialCode: "+965", flag: "kw.svg" },
    { code: "KY", name: "Cayman Islands", dialCode: "+1", flag: "ky.svg" },
    { code: "KZ", name: "Kazakhstan", dialCode: "+7", flag: "kz.svg" },
    { code: "LA", name: "Laos", dialCode: "+856", flag: "la.svg" },
    { code: "LB", name: "Lebanon", dialCode: "+961", flag: "lb.svg" },
    { code: "LC", name: "Saint Lucia", dialCode: "+1", flag: "lc.svg" },
    { code: "LI", name: "Liechtenstein", dialCode: "+423", flag: "li.svg" },
    { code: "LK", name: "Sri Lanka", dialCode: "+94", flag: "lk.svg" },
    { code: "LR", name: "Liberia", dialCode: "+231", flag: "lr.svg" },
    { code: "LS", name: "Lesotho", dialCode: "+266", flag: "ls.svg" },
    { code: "LT", name: "Lithuania", dialCode: "+370", flag: "lt.svg" },
    { code: "LU", name: "Luxembourg", dialCode: "+352", flag: "lu.svg" },
    { code: "LV", name: "Latvia", dialCode: "+371", flag: "lv.svg" },
    { code: "LY", name: "Libya", dialCode: "+218", flag: "ly.svg" },
    { code: "MA", name: "Morocco", dialCode: "+212", flag: "ma.svg" },
    { code: "MC", name: "Monaco", dialCode: "+377", flag: "mc.svg" },
    { code: "MD", name: "Moldova", dialCode: "+373", flag: "md.svg" },
    { code: "ME", name: "Montenegro", dialCode: "+382", flag: "me.svg" },
    { code: "MF", name: "Saint Martin", dialCode: "+590", flag: "mf.svg" },
    { code: "MG", name: "Madagascar", dialCode: "+261", flag: "mg.svg" },
    { code: "MH", name: "Marshall Islands", dialCode: "+692", flag: "mh.svg" },
    { code: "MK", name: "North Macedonia", dialCode: "+389", flag: "mk.svg" },
    { code: "ML", name: "Mali", dialCode: "+223", flag: "ml.svg" },
    { code: "MM", name: "Myanmar", dialCode: "+95", flag: "mm.svg" },
    { code: "MN", name: "Mongolia", dialCode: "+976", flag: "mn.svg" },
    { code: "MO", name: "Macao", dialCode: "+853", flag: "mo.svg" },
    { code: "MP", name: "Northern Mariana Islands", dialCode: "+1", flag: "mp.svg" },
    { code: "MQ", name: "Martinique", dialCode: "+596", flag: "mq.svg" },
    { code: "MR", name: "Mauritania", dialCode: "+222", flag: "mr.svg" },
    { code: "MS", name: "Montserrat", dialCode: "+1", flag: "ms.svg" },
    { code: "MT", name: "Malta", dialCode: "+356", flag: "mt.svg" },
    { code: "MU", name: "Mauritius", dialCode: "+230", flag: "mu.svg" },
    { code: "MV", name: "Maldives", dialCode: "+960", flag: "mv.svg" },
    { code: "MW", name: "Malawi", dialCode: "+265", flag: "mw.svg" },
    { code: "MX", name: "Mexico", dialCode: "+52", flag: "mx.svg" },
    { code: "MY", name: "Malaysia", dialCode: "+60", flag: "my.svg" },
    { code: "MZ", name: "Mozambique", dialCode: "+258", flag: "mz.svg" },
    { code: "NA", name: "Namibia", dialCode: "+264", flag: "na.svg" },
    { code: "NC", name: "New Caledonia", dialCode: "+687", flag: "nc.svg" },
    { code: "NE", name: "Niger", dialCode: "+227", flag: "ne.svg" },
    { code: "NF", name: "Norfolk Island", dialCode: "+672", flag: "nf.svg" },
    { code: "NG", name: "Nigeria", dialCode: "+234", flag: "ng.svg" },
    { code: "NI", name: "Nicaragua", dialCode: "+505", flag: "ni.svg" },
    { code: "NL", name: "Netherlands", dialCode: "+31", flag: "nl.svg" },
    { code: "NO", name: "Norway", dialCode: "+47", flag: "no.svg" },
    { code: "NP", name: "Nepal", dialCode: "+977", flag: "np.svg" },
    { code: "NR", name: "Nauru", dialCode: "+674", flag: "nr.svg" },
    { code: "NU", name: "Niue", dialCode: "+683", flag: "nu.svg" },
    { code: "NZ", name: "New Zealand", dialCode: "+64", flag: "nz.svg" },
    { code: "OM", name: "Oman", dialCode: "+968", flag: "om.svg" },
    { code: "PA", name: "Panama", dialCode: "+507", flag: "pa.svg" },
    { code: "PE", name: "Peru", dialCode: "+51", flag: "pe.svg" },
    { code: "PF", name: "French Polynesia", dialCode: "+689", flag: "pf.svg" },
    { code: "PG", name: "Papua New Guinea", dialCode: "+675", flag: "pg.svg" },
    { code: "PH", name: "Philippines", dialCode: "+63", flag: "ph.svg" },
    { code: "PK", name: "Pakistan", dialCode: "+92", flag: "pk.svg" },
    { code: "PL", name: "Poland", dialCode: "+48", flag: "pl.svg" },
    { code: "PM", name: "Saint Pierre and Miquelon", dialCode: "+508", flag: "pm.svg" },
    { code: "PN", name: "Pitcairn Islands", dialCode: "+64", flag: "pn.svg" },
    { code: "PR", name: "Puerto Rico", dialCode: "+1", flag: "pr.svg" },
    { code: "PS", name: "Palestine", dialCode: "+970", flag: "ps.svg" },
    { code: "PT", name: "Portugal", dialCode: "+351", flag: "pt.svg" },
    { code: "PW", name: "Palau", dialCode: "+680", flag: "pw.svg" },
    { code: "PY", name: "Paraguay", dialCode: "+595", flag: "py.svg" },
    { code: "QA", name: "Qatar", dialCode: "+974", flag: "qa.svg" },
    { code: "RE", name: "Réunion", dialCode: "+262", flag: "re.svg" },
    { code: "RO", name: "Romania", dialCode: "+40", flag: "ro.svg" },
    { code: "RS", name: "Serbia", dialCode: "+381", flag: "rs.svg" },
    { code: "RU", name: "Russia", dialCode: "+7", flag: "ru.svg" },
    { code: "RW", name: "Rwanda", dialCode: "+250", flag: "rw.svg" },
    { code: "SA", name: "Saudi Arabia", dialCode: "+966", flag: "sa.svg" },
    { code: "SB", name: "Solomon Islands", dialCode: "+677", flag: "sb.svg" },
    { code: "SC", name: "Seychelles", dialCode: "+248", flag: "sc.svg" },
    { code: "SD", name: "Sudan", dialCode: "+249", flag: "sd.svg" },
    { code: "SE", name: "Sweden", dialCode: "+46", flag: "se.svg" },
    { code: "SG", name: "Singapore", dialCode: "+65", flag: "sg.svg" },
    { code: "SH", name: "Saint Helena", dialCode: "+290", flag: "sh.svg" },
    { code: "SI", name: "Slovenia", dialCode: "+386", flag: "si.svg" },
    { code: "SJ", name: "Svalbard and Jan Mayen", dialCode: "+47", flag: "sj.svg" },
    { code: "SK", name: "Slovakia", dialCode: "+421", flag: "sk.svg" },
    { code: "SL", name: "Sierra Leone", dialCode: "+232", flag: "sl.svg" },
    { code: "SM", name: "San Marino", dialCode: "+378", flag: "sm.svg" },
    { code: "SN", name: "Senegal", dialCode: "+221", flag: "sn.svg" },
    { code: "SO", name: "Somalia", dialCode: "+252", flag: "so.svg" },
    { code: "SR", name: "Suriname", dialCode: "+597", flag: "sr.svg" },
    { code: "SS", name: "South Sudan", dialCode: "+211", flag: "ss.svg" },
    { code: "ST", name: "São Tomé and Príncipe", dialCode: "+239", flag: "st.svg" },
    { code: "SV", name: "El Salvador", dialCode: "+503", flag: "sv.svg" },
    { code: "SX", name: "Sint Maarten", dialCode: "+1", flag: "sx.svg" },
    { code: "SY", name: "Syria", dialCode: "+963", flag: "sy.svg" },
    { code: "SZ", name: "Eswatini", dialCode: "+268", flag: "sz.svg" },
    { code: "TC", name: "Turks and Caicos Islands", dialCode: "+1", flag: "tc.svg" },
    { code: "TD", name: "Chad", dialCode: "+235", flag: "td.svg" },
    { code: "TF", name: "French Southern Territories", dialCode: "+262", flag: "tf.svg" },
    { code: "TG", name: "Togo", dialCode: "+228", flag: "tg.svg" },
    { code: "TH", name: "Thailand", dialCode: "+66", flag: "th.svg" },
    { code: "TJ", name: "Tajikistan", dialCode: "+992", flag: "tj.svg" },
    { code: "TK", name: "Tokelau", dialCode: "+690", flag: "tk.svg" },
    { code: "TL", name: "Timor-Leste", dialCode: "+670", flag: "tl.svg" },
    { code: "TM", name: "Turkmenistan", dialCode: "+993", flag: "tm.svg" },
    { code: "TN", name: "Tunisia", dialCode: "+216", flag: "tn.svg" },
    { code: "TO", name: "Tonga", dialCode: "+676", flag: "to.svg" },
    { code: "TR", name: "Turkey", dialCode: "+90", flag: "tr.svg" },
    { code: "TT", name: "Trinidad and Tobago", dialCode: "+1", flag: "tt.svg" },
    { code: "TV", name: "Tuvalu", dialCode: "+688", flag: "tv.svg" },
    { code: "TW", name: "Taiwan", dialCode: "+886", flag: "tw.svg" },
    { code: "TZ", name: "Tanzania", dialCode: "+255", flag: "tz.svg" },
    { code: "UA", name: "Ukraine", dialCode: "+380", flag: "ua.svg" },
    { code: "UG", name: "Uganda", dialCode: "+256", flag: "ug.svg" },
    { code: "UM", name: "U.S. Outlying Islands", dialCode: "+1", flag: "um.svg" },
    { code: "US", name: "United States", dialCode: "+1", flag: "us.svg" },
    { code: "UY", name: "Uruguay", dialCode: "+598", flag: "uy.svg" },
    { code: "UZ", name: "Uzbekistan", dialCode: "+998", flag: "uz.svg" },
    { code: "VA", name: "Vatican City", dialCode: "+379", flag: "va.svg" },
    { code: "VC", name: "Saint Vincent and the Grenadines", dialCode: "+1", flag: "vc.svg" },
    { code: "VE", name: "Venezuela", dialCode: "+58", flag: "ve.svg" },
    { code: "VG", name: "British Virgin Islands", dialCode: "+1", flag: "vg.svg" },
    { code: "VI", name: "U.S. Virgin Islands", dialCode: "+1", flag: "vi.svg" },
    { code: "VN", name: "Vietnam", dialCode: "+84", flag: "vn.svg" },
    { code: "VU", name: "Vanuatu", dialCode: "+678", flag: "vu.svg" },
    { code: "WF", name: "Wallis and Futuna", dialCode: "+681", flag: "wf.svg" },
    { code: "WS", name: "Samoa", dialCode: "+685", flag: "ws.svg" },
    { code: "YE", name: "Yemen", dialCode: "+967", flag: "ye.svg" },
    { code: "YT", name: "Mayotte", dialCode: "+262", flag: "yt.svg" },
    { code: "ZA", name: "South Africa", dialCode: "+27", flag: "za.svg" },
    { code: "ZM", name: "Zambia", dialCode: "+260", flag: "zm.svg" },
    { code: "ZW", name: "Zimbabwe", dialCode: "+263", flag: "zw.svg" }
  ];

  const phoneInputs = document.querySelectorAll("[data-phone-input]");

  phoneInputs.forEach((phoneInput) => {
    const countrySelector = phoneInput.querySelector("[data-country-selector]");
    const selectedCountry = phoneInput.querySelector("[data-selected-country]");
    const countryDropdown = phoneInput.querySelector("[data-country-dropdown]");
    const countryList = phoneInput.querySelector("[data-country-list]");
    const countrySearch = phoneInput.querySelector("[data-country-search]");
    const phoneInputField = phoneInput.querySelector("[data-phone-input-field]");
    const countryFlag = phoneInput.querySelector("[data-flag]");

    // Populate country list
    countries.forEach((country) => {
      const countryItem = document.createElement("div");
      countryItem.className = "phone-input__country-item";
      countryItem.innerHTML = `
        <span class="phone-input__country-name">${country.name}</span>
        <span class="phone-input__country-code">${country.dialCode}</span>
      `;
      countryItem.dataset.country = JSON.stringify(country);
      countryList.appendChild(countryItem);
    });

    // Set default country based on data-loaded-country
    const loadedCountryCode = countryFlag.getAttribute("data-loaded-country");
    if (loadedCountryCode) {
      const defaultCountry = countries.find(country => country.code.toLowerCase() === loadedCountryCode.toLowerCase());
      if (defaultCountry) {
        // Update flag
        countryFlag.classList = "";
        countryFlag.classList.add("flag-icon");
        countryFlag.classList.add(`flag-icon-${defaultCountry.code.toLowerCase()}`);

        // Update selected country display
        const selectedCountryName = selectedCountry.querySelector(".phone-input__country-name");
        const selectedCountryCode = selectedCountry.querySelector(".phone-input__country-code");
        if (selectedCountryName) selectedCountryName.textContent = defaultCountry.name;
        if (selectedCountryCode) selectedCountryCode.textContent = defaultCountry.dialCode;

        // Update input value with country code if empty
        if (!phoneInputField.value) {
          phoneInputField.value = defaultCountry.dialCode;
        } else if (!phoneInputField.value.startsWith("+")) {
          phoneInputField.value = defaultCountry.dialCode + phoneInputField.value + " ";
        }
      }
    }

    // Toggle dropdown
    selectedCountry.addEventListener("click", () => {
      countryDropdown.classList.toggle("active");
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", (e) => {
      if (!countrySelector.contains(e.target)) {
        countryDropdown.classList.remove("active");
      }
    });

    // Search countries
    countrySearch.addEventListener("input", (e) => {
      const searchTerm = e.target.value.toLowerCase();
      const countryItems = countryList.querySelectorAll(".phone-input__country-item");

      countryItems.forEach((item) => {
        const country = JSON.parse(item.dataset.country);
        const isVisible =
          country.name.toLowerCase().includes(searchTerm) ||
          country.dialCode.includes(searchTerm);
        item.style.display = isVisible ? "flex" : "none";
      });
    });

    // Select country
    countryList.addEventListener("click", (e) => {
      const countryItem = e.target.closest(".phone-input__country-item");
      if (!countryItem) return;

      const country = JSON.parse(countryItem.dataset.country);

      // Update selected country display
      const selectedCountryName = selectedCountry.querySelector(".phone-input__country-name");
      const selectedCountryCode = selectedCountry.querySelector(".phone-input__country-code");
      if (selectedCountryName) selectedCountryName.textContent = country.name;
      if (selectedCountryCode) selectedCountryCode.textContent = country.dialCode;

      // Update flag
      countryFlag.classList = "";
      countryFlag.classList.add("flag-icon");
      countryFlag.classList.add(`flag-icon-${country.code.toLowerCase()}`);

      // Update input value with country code
      const currentValue = phoneInputField.value.replace(/^\+\d+/, "");
      phoneInputField.value = country.dialCode + currentValue + " ";
      phoneInputField.focus();

      countryDropdown.classList.remove("active");
    });

    // Format phone number on input
    phoneInputField.addEventListener("input", (e) => {
      let value = e.target.value.replace(/\D/g, "");
      if (!value.startsWith("+")) {
        const selectedCountryCode = selectedCountry.querySelector(".phone-input__country-code");
        const dialCode = selectedCountryCode ? selectedCountryCode.textContent : "";
        value = dialCode + value;
      }
      e.target.value = value;
    });
  });
});
